import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { brokeragesApi } from "@/api/brokerages";
import { brokerageKeys } from "@/hooks/brokerages/brokerageKeys";
import { portalAbsorptionKeys } from "@/hooks/portalAbsorption/portalAbsorptionKeys";

// Portal absorption (WS-D1) — the brokerage firm's linked portal login
// (reverse PortalUser.LinkedBrokerageId lookup) + the invite mutation.
// The invite invalidates portalAbsorptionKeys.all (the shared
// PortalAccountCard's contract) in addition to the lookup key.

export function useBrokeragePortalAccount(brokerageId: string | undefined) {
  return useQuery({
    queryKey: brokerageKeys.portalAccount(brokerageId ?? ""),
    queryFn: () => brokeragesApi.portalAccount(brokerageId!),
    enabled: !!brokerageId,
  });
}

export function useInviteBrokeragePortal(brokerageId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => brokeragesApi.portalInvite(brokerageId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: brokerageKeys.portalAccount(brokerageId) });
      qc.invalidateQueries({ queryKey: portalAbsorptionKeys.all });
    },
  });
}
